var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { AppInsights } from "applicationinsights-js";
export default {
    bind: function (el, binding) {
        if (!binding.modifiers)
            return;
        for (var event in binding.modifiers) {
            el.addEventListener(event, function (ev) {
                var properties = typeof binding.value === "function"
                    ? binding.value(el, ev)
                    : {};
                AppInsights.trackEvent(ev.type, __assign({ id: el.id, name: el.name }, properties));
                if (binding.arg === "flush") {
                    AppInsights.flush();
                }
            });
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/Directives/Log.ts
// module id = 76
// module chunks = 24